import { Airport } from 'models/airport';
import { RequestSettings } from 'models/auto/requestSettings';
import { VehicleOption } from 'models/auto/vehicle';
import { LogicalFare } from 'models/logicalFare';

export type VehicleSearchPayload = {
  pickUp: PickUpSearch;
  dropOff: DropOffSearch;
  maxResults?: number;
  currencyCode?: string;
  requestSettings?: RequestSettings;
  sessionToken?: string;
};

export type PickUpSearch = {
  pickUpType: VehiclePlaceType;
  pickUpDateTime: string;
  destinationCode?: string;
  latitude?: number;
  longitude?: number;
  countryCode?: string;
};

export type DropOffSearch = {
  dropOffType: VehiclePlaceType;
  dropOffDateTime?: string;
  destinationCode?: string;
  latitude?: number;
  longitude?: number;
  countryCode?: string;
};

export enum VehiclePlaceType {
  Airport = 'Airport',
  City = 'City',
  LatLong = 'LatLong',
}

export type VehicleSearchResponse = {
  vehicleOption?: VehicleOption[];
  distanceRestriction?: 'Domestic' | 'International';
  searchId?: string;
  resultsAvailableUntil?: string;
  resultsCount?: number;
  lowestLogicalFareList?: LogicalFare[];
};

export interface VehiclePlace extends Airport {
  isAirport: boolean;
  latitude?: number;
  longitude?: number;
  placeId?: string;
  countryCode?: string;
}
